
import { useState } from "react";
import { WordPair } from "@/types/game";

export const useGameState = () => {
  const [rounds, setRounds] = useState<WordPair[]>([]);
  const [currentWord, setCurrentWord] = useState("");
  const [isRevealed, setIsRevealed] = useState(false);
  const [usedWords, setUsedWords] = useState<Set<string>>(new Set());
  const [gameOver, setGameOver] = useState(false);
  const [convergenceRound, setConvergenceRound] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isOwner, setIsOwner] = useState(false);
  const [botHasChosenWord, setBotHasChosenWord] = useState(false);
  const [botIsThinking, setBotIsThinking] = useState(false);
  const [shouldAutoFocus, setShouldAutoFocus] = useState(true);
  const [gameStatus, setGameStatus] = useState<string>("in_progress");
  const [userHasSubmitted, setUserHasSubmitted] = useState(false);
  const [wordError, setWordError] = useState("");
  const [gameStateReady, setGameStateReady] = useState(false);
  const [processingComplete, setProcessingComplete] = useState(true);

  return {
    // State values
    rounds,
    setRounds,
    currentWord,
    setCurrentWord,
    isRevealed,
    setIsRevealed,
    usedWords,
    setUsedWords,
    gameOver,
    setGameOver,
    convergenceRound,
    setConvergenceRound,
    loading,
    setLoading,
    isSubmitting,
    setIsSubmitting,
    isOwner,
    setIsOwner,
    botHasChosenWord,
    setBotHasChosenWord,
    botIsThinking,
    setBotIsThinking,
    shouldAutoFocus,
    setShouldAutoFocus,
    gameStatus,
    setGameStatus,
    userHasSubmitted,
    setUserHasSubmitted,
    wordError,
    setWordError,
    gameStateReady,
    setGameStateReady,
    processingComplete,
    setProcessingComplete
  };
};
